import { Box, IconButton, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { notificationContainerSx } from '../styles/styles'

type WarnNotificationProps = {
  setIsShown: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  notifications: string[]
}

const WarnNotification: FC<WarnNotificationProps> = ({
  notifications,
  setIsShown,
  title,
}) => {
  return (
    <Stack sx={notificationContainerSx} spacing={'8px'}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Stack
          direction={'row'}
          width={'100%'}
          alignItems={'center'}
          spacing={'4px'}
        >
          <Box component='img' src={getImageSrc('warn')} />
          <Typography variant='h6'>{title}</Typography>
        </Stack>
        <IconButton onClick={() => setIsShown(false)}>
          <Box
            component='img'
            src={getImageSrc('close')}
            sx={{ width: '16px' }}
          />
        </IconButton>
      </Stack>
      {notifications.map((notification, index) => (
        <Typography sx={{ color: '#5F5F5F' }} variant='body1' key={index}>
          {notification}
        </Typography>
      ))}
    </Stack>
  )
}

export default observer(WarnNotification)
